import React from 'react'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  tourId: string
}

interface BannerConfig {
  desktopImageId: string
  mobileImageId: string
  altText: string
  link: string
}

const BannerImage = styled(Image)`
  width: 100%;
`

const TOUR_BANNER_MAP: Record<string, BannerConfig> = {
  'tour-e79792ac-e43e-4de0-b682-fa4a1952518c': {
    desktopImageId: 'cross-promo-italy-desktop-banner',
    mobileImageId: 'cross-promo-italy-mobile-banner',
    altText: 'Explore Italy tours',
    link: '/tour/tour-0206690e-757b-45e5-be63-d9601a648555/signature-series-italy-exclusive-foodie-tour-w-matt-preston-and-gary-mehigan-base?preview=true',
  },
  'tour-0206690e-757b-45e5-be63-d9601a648555': {
    desktopImageId: 'cross-promo-spain-desktop-banner',
    mobileImageId: 'cross-promo-spain-mobile-banner',
    altText: 'Explore Spain tours',
    link: '/tour/tour-e79792ac-e43e-4de0-b682-fa4a1952518c/signature-series-spain-foodie-tour-w-matt-preston-gary-mehigan-base',
  },
}

function TourCrossPromoBanner(props: Props) {
  const { tourId } = props

  const bannerConfig = TOUR_BANNER_MAP[tourId]

  if (!bannerConfig) {
    return null
  }

  return (
    <Clickable href={bannerConfig.link}>
      <CSSBreakpoint min="tablet">
        <BannerImage image={{ id: bannerConfig.desktopImageId }} alt={bannerConfig.altText} />
      </CSSBreakpoint>
      <CSSBreakpoint max="mobile">
        <BannerImage image={{ id: bannerConfig.mobileImageId }} alt={bannerConfig.altText} />
      </CSSBreakpoint>
    </Clickable>
  )
}

export default TourCrossPromoBanner
